// The Parked bucket (kanban 08d6b22f): initiatives the group sidelined or that
// are blocked with no end in sight. They are still tracked, so they leave the
// active views without being dropped, and each says why it sits still.

import type { ParkedItem, TeamColors } from './roadmapViewUtils';
import { TeamTags } from './TeamTags';
import styles from './RoadmapV2.module.css';

interface Props {
  items: ParkedItem[];
  teamColors: TeamColors;
  onSelect: (key: string) => void;
}

export function ParkedPanel({ items, teamColors, onSelect }: Props) {
  return (
    <section className={`${styles.panel} ${styles.parkedPanel}`} aria-label="Parked initiatives">
      <div className={styles.panelHead}>
        <h2>Parked: {items.length} initiative{items.length === 1 ? '' : 's'} on hold</h2>
        <span className={styles.meta}>sidelined or blocked indefinitely; hidden from the other views until picked back up</span>
      </div>
      <ul className={styles.parkedList}>
        {items.map(({ initiative: i, reason, waitingOn }) => (
          <li key={i.initiative_key} className={styles.parkedItem}>
            <div className={styles.parkedTitle}>
              <button type="button" className={styles.linkBtn} onClick={() => onSelect(i.initiative_key)}>
                {i.title}
              </button>
              <TeamTags of={i} colors={teamColors} pinnedBy={i.teams_override?.set_by_email ?? null} />
            </div>
            {reason && (
              <div className={styles.parkedWhy}>
                <strong>Why:</strong> {reason}
                {i.park_override && (
                  <span className={styles.meta}> · parked by {i.park_override.set_by_email} on {i.park_override.set_at.slice(0, 10)}</span>
                )}
              </div>
            )}
            {waitingOn.length > 0 && (
              <div className={styles.parkedWhy}>
                <strong>Waiting on:</strong>{' '}
                {waitingOn.map((w, n) => (
                  <span key={w.key ?? `outside-${n}`}>
                    {n > 0 && ', '}
                    {w.key ? (
                      <button type="button" className={styles.linkBtn} onClick={() => onSelect(w.key as string)}>
                        {w.label}
                      </button>
                    ) : (
                      w.label
                    )}
                  </span>
                ))}
              </div>
            )}
            {!reason && waitingOn.length === 0 && (
              <div className={styles.meta}>
                {i.park_override
                  ? `Parked by ${i.park_override.set_by_email} on ${i.park_override.set_at.slice(0, 10)}, no reason given. Merlin asks next run.`
                  : 'Nobody said why it is parked. Merlin asks next run.'}
              </div>
            )}
            <div className={styles.meta}>
              {i.people.length > 0 ? i.people.join(', ') : i.owner ?? 'nobody named'}
              {' · '}last moved {i.updated_at.slice(0, 10)}
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
